import React from 'react';
import { AppIcon } from '../../../components/icons/AppIcon';

interface PlanFeaturesProps {
    features: string[] | Record<string, unknown> | null | undefined;
}

const PlanFeatures: React.FC<PlanFeaturesProps> = ({ features }) => {
    const featureList = Array.isArray(features)
        ? features
        : typeof features === 'object' && features !== null
            ? Object.keys(features)
            : [];

    if (featureList.length === 0) {
        return null;
    }

    return (
        <ul className="flex flex-col max-md:gap-2 md:gap-3 md:border-t md:border-subtle max-md:pt-2 md:pt-5 list-none p-0 m-0 min-w-0">
            {featureList.map((feature, index) => (
                <li
                    key={index}
                    className="flex items-start gap-2 max-md:gap-2 md:gap-2.5 text-body-sm font-medium text-secondary leading-snug"
                >
                    <span
                        className="flex h-4 w-4 md:h-5 md:w-5 shrink-0 items-center justify-center rounded-full bg-primary-subtle text-primary mt-0.5"
                        aria-hidden="true"
                    >
                        <AppIcon name="check" className="h-2.5 w-2.5 md:h-3 md:w-3" />
                    </span>
                    <span className="min-w-0">{String(feature)}</span>
                </li>
            ))}
        </ul>
    );
};

export default PlanFeatures;
